import { useEffect } from 'react';
import { useSession } from '../SessionContext';
import { IUserSession } from '../interfaces/IUserSession';
import { ProfileService } from '../services/profileService';
import { useApiClient } from '../ApiClientProvider';

/**
 * This component syncs the profile image to the session when the user is logged in.
 * It runs when session changes and fetches the image URL from the profile service.
 */
export const ProfileImageSyncer = () => {
    const { session, setSession } = useSession<IUserSession>();
    const managementClient = useApiClient('managementClient');

    useEffect(() => {
        // Only run if user is logged in
        if (!session?.token || !session?.user?.id) {
            return;
        }

        // Skip if image is already populated
        if (session.user.image) {
            return;
        }

        const fetchAndUpdateImage = async () => {
            try {
                const profileService = new ProfileService(managementClient);
                const profileData = await profileService.getProfile();

                if (profileData?.imageUrl && session) {
                    // Update session with image
                    setSession({
                        ...session,
                        user: {
                            ...session.user,
                            image: profileData.imageUrl
                        }
                    });
                }
            } catch (error) {
                console.error('Failed to fetch profile image:', error);
                // Silently fail - don't break user experience
            }
        };

        fetchAndUpdateImage();
    }, [managementClient, session?.token, session?.user?.id, session?.user?.image, setSession]); // Only run when auth/session image inputs change

    return null; // This component doesn't render anything
};
